import {
    createApp,
} from 'vue';
import TemplateDialog from './components/TemplateDialog.vue';
import DialogMessage from './components/DialogMessage.vue';
import { localization } from './l10n';
import vuetify from './plugins/vuetify';

let $mounted;

export default function Dialog(component, payload, api) {
    return new Promise((release, reject) => {
        let dialog = null;
        const dispose = () => {
            if (dialog != null) {
                if (dialog === $mounted) {
                    $mounted = undefined;
                    dialog.unmount();
                }
            }
        };
        const context = {
            release,
            reject,
            dispose,
            component,
            payload,
        };
        if ($mounted != null) {
            $mounted.unmount();
        }
        const template = TemplateDialog;
        dialog = createApp(template, context);
        let el = document.getElementById('dlg');
        if (el == null) {
            el = document.createElement('div');
            document.body.appendChild(el);
            el.id = 'dlg';
        }
        $mounted = dialog;
        dialog.use(vuetify);
        dialog.use(localization);
        if (api !== undefined) {
            dialog.use(api);
        }
        dialog.mount(el);
    });
}

export function MessageBox(title, message, payload = {}) {
    const $payload = {
        title,
        value: message,
    };
    if (payload != null) {
        const keys = Object.keys(payload);
        for (let i = 0; i < keys.length; i += 1) {
            const key = keys[i];
            const value = payload[key];
            $payload[key] = value;
        }
    }
    return Dialog(DialogMessage, $payload);
}
